import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {genderTypeAction} from "redux/actions";


export default function UpdateGenderType({editableDetails, onUpdate}) {

    const [Gendercode, setGendercode] = useState('');
    const [description, setDescription] = useState('');
    const [updateid, setUpdateid] = useState(0);


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        setGendercode(editableDetails.gender_code);
        setDescription(editableDetails.description);
        setUpdateid(editableDetails.id);
    }, [editableDetails]);

    const updateData = () =>{
        dispatch(genderTypeAction.update({ id: updateid, name: Gendercode, desc: description}));
        setGendercode('');
        setDescription('');
        onUpdate();
    } 

   
    return (
        <div>
            <h2>Update Gender Types</h2>
            <form action="/action_page.php">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="gender_code">Gender Code:</label>
                    <input type="text" className="form-control" id="gender_code" placeholder="Enter Gender Code" name="gender_code" onChange={e => setGendercode(e.target.value)} value={Gendercode}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="description">Description:</label>
                    <input type="text" className="form-control" id="description" placeholder="Enter Gender Description" name="description" onChange={e => setDescription(e.target.value)} value={description} />
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={updateData}>Update</button>
                </div>
            </form>
        </div>
    );
}
